module.exports = __webpack_public_path__ + "img/99_6.e27d928c.png";